import { createFileRoute } from "@tanstack/react-router"
import { LoginForm } from "@/components/ui/auth/LoginForm"

type LoginSearch = {
  role?: string
}

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    return {
      role: (search.role as string) || undefined,
    }
  },
  component: LoginPage,
})

function LoginPage() {
  return <LoginForm />
}
